import { render, staticRenderFns } from "./SeatSelectionModal.vue?vue&type=template&id=2b274320&scoped=true"
import script from "./SeatSelectionModal.vue?vue&type=script&lang=js"
export * from "./SeatSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./SeatSelectionModal.vue?vue&type=style&index=0&id=2b274320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b274320",
  null
  
)

export default component.exports